import { isIE } from '@blk/aw-utils-core';

export const downloadBlob = (blob: Blob, filename: string, extension: string = 'xlsx') => {
  if (isIE()) {
    // For IE11 https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/1029
    (window.navigator as unknown as { msSaveOrOpenBlob: (blob: Blob, extension: string) => void }).msSaveOrOpenBlob(
      blob,
      `${filename}.${extension}`
    );
  } else {
    // For all other browsers
    const url = window.URL.createObjectURL(blob);
    const aTag = document.createElement('a');
    document.body.appendChild(aTag);
    aTag.href = url;
    aTag.download = `${filename}.${extension}`;
    aTag.onclick = (e) => {
      e.stopPropagation();
    };
    aTag.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(aTag);
  }
};

export const downloadFile = (filePath: string, filename: string, extension: string = 'csv') => {
  const aTag = document.createElement('a');
  aTag.href = filePath;
  aTag.download = `${filename}.${extension}`;
  aTag.click();
};
